<h2>{{ title }}</h2>
<app-debugger-group>
  <app-debugger [json]="someSelected" title="someSelected"></app-debugger>
  <app-debugger [json]="allSelected" title="allSelected"></app-debugger>
  <app-debugger [json]="members" title="members"></app-debugger>
</app-debugger-group>
<ng-template #selectionMenu>
  <button
    mat-stroked-button
    [mat-menu-trigger-for]="selectedActions"
    [disabled]="!anySelected"
  >
    <div fxLayout="row" fxLayoutAlign="center center">
      <strong
        >{{ selectedCount }}
        {{
          (selectedCount === 1 ? singularItemName : pluralItemName) | titlecase
        }}
        Selected
      </strong>
      <mat-icon>arrow_drop_down</mat-icon>
    </div>
  </button>
  <mat-menu #selectedActions>
    <ng-container
      *ngTemplateOutlet="
        selectedItemsActionsTemplate;
        context: { $implicit: selectedMembers }
      "
    >
    </ng-container>
  </mat-menu>
</ng-template>
<ng-container
  *ngTemplateOutlet="
    subtextTemplate;
    context: { $implicit: memberCount, collectiveName: collectiveName }
  "
></ng-container>

@if (memberCount === 0) {
  <!-- A header row whose only control is "select all" is meaningless with
       nothing to select, so the table is replaced outright rather than
       rendered empty. -->
  <p class="membership-empty">
    <mat-icon aria-hidden="true">inbox</mat-icon>
    <span>No {{ pluralItemName }} to show.</span>
  </p>
} @else {
  <div class="table-responsive">
    <table mat-table [dataSource]="members" class="mat-elevation-z0">
      <ng-container matColumnDef="selection">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            [ngModel]="allSelected"
            [indeterminate]="someSelected"
            (change)="toggleSelectAll()"
          ></mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let member">
          <mat-checkbox
            [checked]="selectedMembers.includes(member.id)"
            (change)="selectItem($event, member.id)"
          ></mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>
          @if (anySelected && showName) {
            <ng-container *ngTemplateOutlet="selectionMenu"></ng-container>
          }
          @if (!anySelected && showName) {
            Name
          }
        </th>
        <td mat-cell *matCellDef="let member">
          <div
            fxLayout="row"
            fxLayoutAlign="start center"
            class="member"
            [ngClass]="{
              currentMember: member.isCurrent,
              isOwner: member.isOwner,
            }"
          >
            @if (showAvatar) {
              <app-avatar-icon
                [pictureUrl]="member.pictureUrl"
              ></app-avatar-icon>
            }
            {{ member.investigatorName | fullName }}
            @if (member.isOwner) {
              (project owner)
            }
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>
          @if (anySelected && !showName) {
            <ng-container *ngTemplateOutlet="selectionMenu"></ng-container>
          }
          @if (!anySelected) {
            Email
          }
        </th>
        <td mat-cell *matCellDef="let member">{{ member.email }}</td>
      </ng-container>

      <ng-container matColumnDef="groups">
        <th mat-header-cell *matHeaderCellDef>Project Groups</th>
        <td mat-cell *matCellDef="let member">
          @for (group of member.groups; track group) {
            <span>{{ group.name }}</span>
          }
          @if (member.groups?.[0]?.name !== 'Administrator') {
            <span>Reviewer</span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let member">
          <ng-container
            *ngTemplateOutlet="
              itemActionTemplate;
              context: { $implicit: member }
            "
          ></ng-container></td
      ></ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let member; columns: displayedColumns"
        [ngClass]="{ selected: selectedMembers.includes(member.id) }"
      ></tr>
    </table>
  </div>
}
